/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryModule
 * Purpose		: Module for ProductsbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { ProductsbyCategoryService } from './ProductsbyCategory.service';
import { ProductsbyCategoryListComponent } from './ProductsbyCategoryList.component';
import { ProductsbyCategorySearchComponent } from './ProductsbyCategorySearch.component';
import { ProductsbyCategoryDetailsComponent } from './ProductsbyCategoryDetails.component';

import { ProductsbyCategoryRoutingModule } from './ProductsbyCategory-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    ProductsbyCategoryRoutingModule
  ],
  declarations: [
    ProductsbyCategoryListComponent,
	ProductsbyCategorySearchComponent,
	ProductsbyCategoryDetailsComponent
  ],
  providers: [
    ProductsbyCategoryService
  ]
})

export class ProductsbyCategoryModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsbyCategory/ProductsbyCategory.module.ts